import { useMutation, useQueryCache } from 'react-query';
import { EventCategoryRestrictionAPI } from 'api/admin/eventCategoryRestriction';
import { COMPETITIONS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useRemoveEventCategoryRestriction() {
  const queryCache = useQueryCache();

  return useMutation(EventCategoryRestrictionAPI.remove, {
    onSuccess: ({ message }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(COMPETITIONS);
    },
  });
}
